import { render } from "./AboutReferences.vue?vue&type=template&id=358adf93"
import script from "./AboutReferences.vue?vue&type=script&lang=js"
export * from "./AboutReferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__